
@if (!scriptStatus.error) {
  <div>
    <!-- Card Number -->
    <input-wrap [label]="'Card Number' | translate"
      [messages]="{required: 'Please enter a valid card number'}"
      class="barclaycard-input"
      [required]="true">
    <div class="pos-relative">
      @if (isSelected()) {
        <input
          type="checkbox"
          class="visually-hidden"
          [(ngModel)]="isCardNumberValid"
          name="numberValid"
          required />
      }
      <div id="barclaycard-microform-number-container"
        style="background-color: white;"
        [ngClass]="isCardNumberValid && 'input-tick'"
      class="input is-focus w-12 p-l-3 p-r-3"></div>
      @if (creditCardType) {
        <payment-icon
          [method]="paymentIconMethod"
          [style.fontSize.px]="24"
        class="pos-absolute right-1 top-50 m-r-12"></payment-icon>
      }
    </div>
  </input-wrap>
  <!-- Expiry Month -->
  <input-wrap [label]="'Expiry month' | translate"
    class="barclaycard-input pos-relative block m-t-5 w-6 p-r-2"
    [messages]="{required: 'Please enter a valid expiry month'}"
    (offClick)="closeZippy('barclaycardMonth')"
    [required]="true">
  <div class="pos-relative">
    @if (isSelected()) {
      <input
        type="hidden"
        name="expMonth"
        [(ngModel)]="creditCardExpMonth"
        placeholder="MM"
        required>
    }
    <div zippyToggle="barclaycardMonth"
      class="input pos-relative cursor-pointer bg-col-w p-l-3 p-r-3 w-12"
      style="background-color: white;font-size:14px;"
      [ngClass]="!creditCardExpMonth && 'col-4-x col-4-l col-4-m col-4-s'">
      {{creditCardExpMonth || 'MM'}}
      <div class="m-l-2 pos-absolute right-5 col-1 top-50 flex flex-middle">
        <i zippyName="barclaycardMonth"
          zippyClass="flip"
        class="indicator icon-chevron-down icon-medium "></i>
      </div>
    </div>
    <div class="pos-absolute hide-up-container">
      <div class="ng-hide ng-hide-animate z-2 hide-up hide-up-100"
        zippyClass="!ng-hide"
        zippy="barclaycardMonth">
        @for (month of months; track month) {
          <div class="w-12 cursor-pointer bg-col-w p-t-1 p-b-1 p-r-3 p-l-3"
            zippyClose="barclaycardMonth"
            (click)="selectMonth(month)"
            >
            {{month}}
          </div>
        }
      </div>
    </div>
  </div>
</input-wrap>
<!-- Expiry Year-->
<input-wrap [label]="'Expiry year' | translate"
  class="barclaycard-input pos-relative block m-t-5 w-6 p-l-2"
  [messages]="{required: 'Please enter a valid expiry year'}"
  (offClick)="closeZippy('barclaycardYear')"
  [required]="true">
@if (isSelected()) {
  <input
    class="input is-focus p-l-3 p-r-3"
    type="hidden"
    name="expYear"
    [(ngModel)]="creditCardExpYear"
    required>
}
<div zippyToggle="barclaycardYear"
  [ngClass]="!creditCardExpYear && 'col-4-x col-4-l col-4-m col-4-s'"
  style="background-color: white;font-size:14px;"
  class="pos-relative input cursor-pointer bg-col-w p-l-3 p-r-3 w-12">
  {{creditCardExpYear || 'YYYY'}}
  <div class="m-l-2 pos-absolute right-5 col-1 top-50 flex flex-middle">
    <i zippyName="barclaycardYear"
      zippyClass="flip"
    class="indicator icon-chevron-down icon-medium"></i>
  </div>
</div>
<div class="pos-absolute hide-up-container">
  <div class="ng-hide ng-hide-animate z-2 hide-up hide-up-100"
    zippy="barclaycardYear">
    @for (year of years; track year) {
      <div class="w-12 cursor-pointer bg-col-w p-t-1 p-b-1 p-r-3 p-l-3"
        zippyClose="barclaycardYear"
        (click)="selectYear(year)"
        >
        {{year}}
      </div>
    }
  </div>
</div>
</input-wrap>
<!-- CVV -->
<input-wrap [label]="'CVC/CVV' | translate"
  [messages]="{required: 'Please enter card security code'}"
  class="barclaycard-input block m-t-5 w-6 p-r-2"
  [required]="true">
@if (isSelected()) {
  <input
    type="checkbox"
    class="visually-hidden"
    [(ngModel)]="isCvvValid"
    name="cvvValid"
    required />
}
<div id="barclaycard-microform-cvv-container"
  style="background-color: white;"
  [ngClass]="isCvvValid && 'input-tick'"
class="input is-focus w-12 p-l-3 p-r-3"></div>
</input-wrap>
@if (canSaveCard) {
  <input-wrap
    class="m-t-5 block">
  <checkbox name="saveCard"
    [(ngModel)]="saveCard">
    <span class="p2 block">
    Save for my next payment.</span>
  </checkbox>
</input-wrap>
}
</div>
}

<result class="block"
  [duration]="'permanent'"
[status]="scriptStatus"></result>
<result class="block"
  [duration]="'permanent'"
[status]="tokenStatus"></result>

<div #cardinalContainer></div>
